export default __webpack_public_path__ + "static/media/fail.1fa37299.png";